export interface IImageMockup{
    configId:string;
    id:string;
    sortOrder:number; 
    status:ImageMockupStatusType;
    fileName: string;    
    tempFileName: string;
}
export class ImageMockup{
    configId:string;
    id:string;
    sortOrder:number; 
    status:ImageMockupStatusType;
    fileName: string;    
    tempFileName: string;
}
export type ImageMockupStatusType="SUCCESS"|"RUNNING"|"WAITING"|"FAILURE";